"use client";
import React, { forwardRef } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  BUTTON_GRADIENTS,
  BUTTON_TYPE_GRADIENTS,
  DEFAULT_BUTTON_SIZE,
  DEFAULT_BUTTON_WIDTH,
  DEFAULT_BORDER_RADIUS,
  DEFAULT_MIN_WIDTH,
} from "./constants";

const ButtonComponent = forwardRef((props, ref) => {
  const {
    className,
    id,
    onClick,
    icon,
    text,
    type,
    color,
    borderRadius = DEFAULT_BORDER_RADIUS,
    minwidth = DEFAULT_MIN_WIDTH,
    noTextSwap = false,
    size = DEFAULT_BUTTON_SIZE,
    width = DEFAULT_BUTTON_WIDTH,
    children,
    disabled = false,
    withoutborder = false,
    ...rest
  } = props;

  const getGradient = () => {
    if (type && BUTTON_TYPE_GRADIENTS[type]) {
      return BUTTON_TYPE_GRADIENTS[type];
    }
    if (color && BUTTON_GRADIENTS[color]) {
      return BUTTON_GRADIENTS[color];
    }
    return "bg-transparent";
  };

  const buttonContent = (
    <>
      {icon}
      {text}
      {children}
    </>
  );

  return (
    <button
      {...rest}
      ref={ref}
      type="button"
      id={id}
      onClick={onClick}
      className={clsx(
        getGradient(),
        " rounded cursor-pointer flex flex-col items-center group overflow-hidden relative transition-all duration-300 py-2 px-3 ",
         size &&`text-${size}`,
         disabled && "cursor-not-allowed opacity-50 pointer-events-none",
         width && `w-${width}`,
         !noTextSwap && "relative",
         withoutborder && "border-none",
        className
      )}
    >
      {!noTextSwap ? (
        <>
          <span className="group-hover:translate-y-[-30px] transition-all duration-300 group-hover:invisible flex items-center">
            {buttonContent}
          </span>
          <span className="absolute group-hover:translate-y-0 translate-y-[30px] transition-all duration-300 invisible group-hover:visible flex items-center">
            {buttonContent}
          </span>
        </>
      ) : (
        <span className={clsx("flex items-center justify-end gap-1", 
          width && `w-${width}`
        )}>{buttonContent}</span>
      )}
    </button>
  );
});

ButtonComponent.displayName = "ButtonComponent";

ButtonComponent.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.node,
  text: PropTypes.string,
  type: PropTypes.oneOf(["cancel", "reset", "apply"]),
  color: PropTypes.oneOf(["blue", "red", "gray", "green", "darkMode"]),
  borderRadius: PropTypes.string,
  noTextSwap: PropTypes.bool,
  children: PropTypes.node,
};

ButtonComponent.defaultProps = {
  className: null,
  id: null,
  onClick: null,
  icon: null,
  text: "",
  type: null,
  color: "blue",
  borderRadius: "10px",
  noTextSwap: false,
  children: null,
};

export default ButtonComponent;
